export default {
    props: {
        modalProps: {},
        open: false,
    },
    data() {
        return {
            isOpen: false,
            value: undefined,
        }
    },
    watch: {
        open(newVal) {
            if (newVal) {
                this.isOpen = true;
            }
        }
    },
    methods: {
        onCancel(e) {
            //e.trigger = 'cancel'
            this.$refs.modal.hide()
            this.hide(e)
        },
        onOk(e) {
            //e.trigger = 'ok'
            this.$refs.modal.hide()
            this.hide(e)
        },

        show() {
            return new Promise((resolve) => {
                this.resolve = resolve;
                this.$refs.modal.show();
            })
        },

        hide(e = {}) {
            if (this.resolve) {
                e.value = this.value
                this.resolve(e)
                this.resolve = null
            }
            this.$refs.modal.hide()
        },

        onHidden(e) {
            if (this.resolve) this.resolve(e)
        }
    }
}
